import { axiosInstance } from "../../Interceptor";
import { FETCH_REPORTS } from "../utils/const";

export const fetchReports = (reportType, form) => {
    return {
      type: FETCH_REPORTS,
      payload: axiosInstance.post(`/reports/${reportType}`, form),
      meta: reportType,
    };
  };